export enum HttpStatus {
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  REQUEST_TIMEOUT = 408,
  CONFLICT = 409,
  PAYLOAD_TOO_LARGE = 413,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
}

// Value of error.name for errors thrown by ky on non-2xx responses
export const HTTP_ERROR_NAME = 'HTTPError'

export const ACCESS_DENIED_STATUSES = [
  HttpStatus.FORBIDDEN,
  HttpStatus.NOT_FOUND,
]

export const HTTP_TIMEOUT_MS = 30000
export const HTTP_RETRY_LIMIT = 2
export const HTTP_RETRY_STATUS_CODES = [
  HttpStatus.UNAUTHORIZED,
  HttpStatus.REQUEST_TIMEOUT,
  HttpStatus.PAYLOAD_TOO_LARGE,
  HttpStatus.TOO_MANY_REQUESTS,
  HttpStatus.NOT_IMPLEMENTED,
  HttpStatus.BAD_GATEWAY,
  HttpStatus.SERVICE_UNAVAILABLE,
  HttpStatus.GATEWAY_TIMEOUT,
]
